/* MYNEEED Cinematic Hero — GSAP ScrollTrigger Frame Sequence */
(function () {
  'use strict';

  const FRAME_COUNT = 37;
  const canvas = document.getElementById('mn-canvas');
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  const heroSection = document.getElementById('mn-hero-section');
  const heroWrap = document.querySelector('.mn-hero__sticky');

  // Frame image objects — declared BEFORE resizeCanvas call
  const frames = new Array(FRAME_COUNT);
  let loadedCount = 0;
  let currentFrame = 0;

  // Resize canvas to viewport
  function resizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    if (frames[currentFrame]?.complete) drawFrame(currentFrame);
  }

  window.addEventListener('resize', resizeCanvas);
  resizeCanvas();

  function getFrameUrl(i) {
    const num = String(i + 1).padStart(3, '0');
    // Shopify: flat assets folder — base contains full CDN prefix
    // Local preview: base = './assets/', filename = 'mn-frame-001.jpg'
    const base = canvas.dataset.framesBase || '';
    return base + 'mn-frame-' + num + '.jpg';
  }

  function drawFrame(index) {
    const img = frames[Math.max(0, Math.min(index, FRAME_COUNT - 1))];
    if (!img || !img.complete) return;
    const scale = Math.max(canvas.width / img.naturalWidth, canvas.height / img.naturalHeight);
    const x = (canvas.width - img.naturalWidth * scale) / 2;
    const y = (canvas.height - img.naturalHeight * scale) / 2;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, x, y, img.naturalWidth * scale, img.naturalHeight * scale);
  }

  function handleFrameLoad(index, callback) {
    loadedCount++;
    if (index === 0) {
      drawFrame(0);
      if (heroWrap) heroWrap.classList.add('mn-hero--loaded');
    }
    if (loadedCount === FRAME_COUNT && callback) callback();
  }

  function preloadFrames(callback) {
    for (let i = 0; i < FRAME_COUNT; i++) {
      (function(index) {
        const img = new Image();
        img.onload  = function() { handleFrameLoad(index, callback); };
        img.onerror = function() { handleFrameLoad(index, callback); };
        frames[index] = img;
        img.src = getFrameUrl(index);
        // Cached images: onload won't fire — check synchronously
        if (img.complete) handleFrameLoad(index, callback);
      })(i);
    }
  }

  function initGSAP() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      console.warn('MYNEEED: GSAP not loaded');
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    // Frame scroll animation
    const obj = { frame: 0 };
    gsap.to(obj, {
      frame: FRAME_COUNT - 1,
      snap: 'frame',
      ease: 'none',
      scrollTrigger: {
        trigger: heroSection,
        start: 'top top',
        end: 'bottom top',
        scrub: 0.5,
      },
      onUpdate: function () {
        currentFrame = Math.round(obj.frame);
        drawFrame(currentFrame);
      }
    });

    // Hero text entrance (fallback if frames already loaded)
    if (loadedCount > 0 && heroWrap) heroWrap.classList.add('mn-hero--loaded');

    // Scroll indicator fades out on scroll
    const scrollIndicator = document.querySelector('.mn-hero__scroll');
    if (scrollIndicator) {
      ScrollTrigger.create({
        trigger: heroSection,
        start: 'top top',
        end: '15% top',
        scrub: true,
        onUpdate: (self) => {
          scrollIndicator.style.opacity = 1 - self.progress * 3;
        }
      });
    }

    // Kinetic text reveal
    gsap.utils.toArray('.mn-kinetic-word').forEach(function (word, i) {
      gsap.fromTo(word,
        { opacity: 0, y: 40 },
        {
          opacity: 1, y: 0, duration: 0.7,
          delay: i * 0.08,
          ease: 'power3.out',
          scrollTrigger: { trigger: word, start: 'top 88%' }
        }
      );
    });

    // Product cards reveal
    gsap.utils.toArray('.mn-product-card').forEach(function (card, i) {
      gsap.fromTo(card,
        { opacity: 0, y: 50 },
        {
          opacity: 1, y: 0, duration: 0.7,
          delay: i * 0.1,
          ease: 'power3.out',
          scrollTrigger: { trigger: card, start: 'top 88%' }
        }
      );
    });

    // Stat counters
    gsap.utils.toArray('.mn-stat__number').forEach(function (el) {
      const target = parseInt(el.dataset.target, 10);
      const valEl = el.querySelector('.mn-stat__val');
      gsap.fromTo({ val: 0 }, { val: target },
        {
          duration: 2,
          ease: 'power2.out',
          scrollTrigger: { trigger: el, start: 'top 80%', once: true },
          onUpdate: function () {
            const n = Math.round(this.targets()[0].val).toLocaleString('de-DE');
            if (valEl) valEl.textContent = n;
            else el.textContent = n;
          }
        }
      );
    });

    // Parallax about section
    const aboutBg = document.querySelector('.mn-about__bg');
    if (aboutBg) {
      gsap.to(aboutBg, {
        yPercent: -20,
        ease: 'none',
        scrollTrigger: {
          trigger: '.mn-about',
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
    }
  }

  // Init
  preloadFrames(function () { drawFrame(0); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGSAP);
  } else {
    initGSAP();
  }
})();
